import { render, staticRenderFns } from "./AS_Aiib.vue?vue&type=template&id=660f5c58&scoped=true&"
import script from "./AS_Aiib.vue?vue&type=script&lang=js&"
export * from "./AS_Aiib.vue?vue&type=script&lang=js&"
import style0 from "./AS_Aiib.vue?vue&type=style&index=0&id=660f5c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660f5c58",
  null
  
)

export default component.exports